<template lang="pug">
div
    div.row
        div.col-xs-9
            small.pull-right Subtotal
        div.col-xs-3
            small.pull-right {{ subTotal }}

    div.row(v-if="totalSaving > 0.00")
        div.col-xs-9
            small.pull-right Total Saving
        div.col-xs-3
            small.pull-right {{ totalSaving }}

    // order group charges
    div.row(v-for="charge in groupCharges")
        div.col-xs-9
            small.pull-right {{ charge.name }}
        div.col-xs-3
            small.pull-right {{ charge.applied_amount }}

    // order group taxes
    div.row(v-for="tax in groupTaxes")
        div.col-xs-9
            small.pull-right {{ tax.name }}
        div.col-xs-3
            small.pull-right {{ tax.applied_amount }}

    //- Discount list
    div.row(v-for="discount in discounts")
        div.col-xs-9
            div.pull-right.text-right
                small {{ discount.name }}
                small.block.text-muted(v-if="discount.remarks !== ''") {{ discount.remarks }}
        div.col-xs-3
            small.pull-right {{ discount.amount }}

    //- Total after discount
    div.row(v-if="hasDiscount")
        div.col-xs-9
            small.pull-right After Discount
        div.col-xs-3
            small.pull-right {{ totalAfterDiscount }}

    //- rounding
    div.row(v-if="paymentName.includes('cash')")
        div.col-xs-9
            small.pull-right Rounding
        div.col-xs-3
            small.pull-right {{ rounding }}

    //- grand total
    div.row.text-md
        div.col-xs-9
            small.pull-right.grand-total-label Grand Total
        div.col-xs-3.grand-total-amount
            small.pull-right {{ grandTotal }}

    //- payments
    div.row(v-for="payment in payments")
        .col-xs-12(v-if="payment.card")
            .row
                .col-xs-9.text-muted
                    small.pull-right {{ getTerminalName(payment) }}
            .row
                .col-xs-9
                    small.pull-right(v-if="payment.reference_number == null") {{ payment.card.name }}
                    small.pull-right(v-else) {{ payment.card.name }} ({{ payment.reference_number }})
                .col-xs-3
                    small.pull-right {{ payment.amount }}

        .col-xs-12(v-else-if="payment.ewallet")
            .row
                .col-xs-9.text-muted
                    small.pull-right {{ getTerminalName(payment) }}
            .row
                .col-xs-9
                    small.pull-right(v-if="payment.reference_number == null") {{ payment.ewallet.name }}
                    small.pull-right(v-else) {{ payment.ewallet.name }} ({{ payment.reference_number }})
                .col-xs-3
                    small.pull-right {{ payment.amount }}

        .col-xs-12(v-else)
            .row
                .col-xs-9
                    small.pull-right(v-if="payment.reference_number == null") {{ payment.name }}
                    small.pull-right(v-else-if="payment.remarks == 'Shell Voucher'") {{ payment.remarks }}
                    small.pull-right(v-else) {{ payment.name }} ({{ payment.reference_number }})
                .col-xs-3
                    small.pull-right {{ payment.type === 0 ? payment.original_amount ? payment.original_amount : payment.amount : payment.amount }}

    //- change
    div.row(v-if="paymentName.includes('cash')")
        div.col-xs-9
            small.pull-right Change
        div.col-xs-3
            small.pull-right {{ totalChange }}
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transaction', [
            'receipt',
            'discounts',
            'totalDiscount',
            'totalAfterDiscount',
            'charges',
            'taxes',
            'totalChange',
            'payments',
            'fuel',
            'paymentName',
            'subTotal',
            'grandTotal',
            'rounding',
            'totalSaving',
            'orderCharges',
            'orderTaxes',
        ]),

        hasDiscount() {
            return this.discounts.length > 0;
        },

        modifySubTotal() {
            let subtotal = this.subTotal;

            let charges = this.orderCharges
                .map(f => {
                    return parseFloat(f.applied_amount);
                })
                .reduce((a, b) => a + b, 0);

            return (parseFloat(subtotal) - parseFloat(charges)).toFixed(2);
        },

        groupCharges() {
            let groupCharge = _.groupBy(this.orderCharges, 'charge_id');

            return _.map(groupCharge, rows => {
                return {
                    name: rows[0].name,
                    applied_amount: rows
                        .map(row => parseFloat(row.applied_amount))
                        .reduce((a, b) => a + b, 0)
                        .toFixed(2),
                };
            });
        },

        groupTaxes() {
            let groupTax = _.groupBy(this.orderTaxes, 'tax_id');

            return _.map(groupTax, rows => {
                return {
                    name: rows[0].name,
                    applied_amount: rows
                        .map(row => parseFloat(row.applied_amount))
                        .reduce((a, b) => a + b, 0)
                        .toFixed(2),
                };
            });
        },
    },

    methods: {
        getTerminalName(payment) {
            if (payment.terminal_id && payment.terminal_type) {
                return `${payment.terminal_type} (${payment.terminal_id})`;
            }

            return payment.name;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/amount.vue